import { render } from "./LoadingElement.vue?vue&type=template&id=fc9410ba"
import script from "./LoadingElement.vue?vue&type=script&lang=js"
export * from "./LoadingElement.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__